module.exports.sitemapNames = {
    index: '/learn-sitemap.xml',
    page: 'page',
    post: 'post',
    user: 'author',
    category: 'category',
};

module.exports.query = `
{
    allWpPost(filter: {cdmfields: {seo: {noindex: {ne: true}}}}) {
        edges {
            node {
                id
                uri
                slug
                dateGmt
                cdmfields {
                    eat {
                        post_updated_date
                    }
                    legacymeta {
                        qlmigArticleImage
                    }
                }
                featuredImage {
                    node {
                      localFile {
                        childImageSharp {
                          fluid {
                            srcWebp
                            src
                          }
                        }
                      }
                    }
                }
            }
        }
    }
    allWpPage(filter: {cdmfields: {seo: {noindex: {ne: true}}}}) {
        edges {
            node {
                id
                uri
                slug
                isFrontPage
                isPostsPage
            }
        }
    }
    allWpUser( filter: {cdmfields: {seo: {noindex: {ne: true}}}, posts: {nodes: {elemMatch: {id: {glob: "*"}}}}} ) {
        edges {
            node {
                id
                uri
                slug
            }
        }
    }
    allWpCategory(filter: {cdmfields: {seo: {noindex: {ne: true}}}}) {
        edges {
            node {
                id
                uri
                slug
            }
        }
    }
}
`;